module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/6LIVQZ2UX6vOctfaN5NwcZ-136b53dc334e8759807e21d5439e1c8b.jpg";